<script lang="ts">
	import { colors } from '$lib/theme/colors';
	import './CarbonChartsStyles.css';
	import { GaugeChart } from '@carbon/charts-svelte';

	export let value: number;
	export let title = '';
	export let height = '250px';
	export let type: 'semi' | 'full' = 'full';
	export let color = 'primary';

	$: data = [
		{
			group: 'value',
			value: value
		}
	];

	$: options = {
		title: title,
		height: height,
		gauge: {
			type: type,
			alignment: 'center'
		},
		color: {
			scale: {
				value: colors[color]
			}
		},
		data: {
			loading: !data.length
		}
	};
</script>

<div>
	<svelte:component this={GaugeChart} {data} {options} />
</div>

<style lang="postcss">
	div :global(.toolbar) {
		display: none;
	}
	div :global(.title) {
		text-align: center;
		padding-right: 0;
	}
</style>
